import React from "react";
import { Card } from "antd";
import { STAMP_CODE_VERIFIED, STAMP_STATUS, STATUS_VERIFY } from "@/constants";
import { convertIsoToDate, isEmpty } from "@/utils";
import { useScanQrcodeStore } from "@/store";

const VerifyInfo: React.FC<{ className?: string }> = ({ className }) => {
  const { stamp_code } = useScanQrcodeStore();
  const { customer, agency, serial, first_verification_at } = stamp_code || {};
  const _STAMP_CODE_VERIFIED = [...STAMP_CODE_VERIFIED, STATUS_VERIFY.OVER_LIMITED, STAMP_STATUS.WARRANTY_REPLACED];

  const InfoRow: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <div className="grid grid-cols-12 gap-4 mb-3">
      <div className="col-span-5">{label}</div>
      <div className="col-span-7 text-right text-[#463E37] font-semibold">{value}</div>
    </div>
  );

  if (isEmpty(customer) && isEmpty(agency) && !_STAMP_CODE_VERIFIED.includes(stamp_code.status)) {
    return null;
  }

  return (
    <Card title={<div className="text-[#F38020] text-[16px] font-bold">Thông tin xác thực</div>} className={className}>
      <div className="py-3">
        <dl>
          <InfoRow label="Họ tên" value={customer?.name || agency?.name || "--"} />

          <InfoRow label="Số điện thoại" value={customer?.phone || agency?.phone || "--"} />

          <InfoRow
            label="Xác thực ngày"
            value={first_verification_at ? convertIsoToDate(first_verification_at) : "--"}
          />

          {stamp_code?.status === STAMP_STATUS.WARRANTY_REPLACED && (
            <InfoRow label="Serial thay bảo hành" value={serial || "--"} />
          )}
        </dl>
      </div>
    </Card>
  );
};

export default VerifyInfo;
